<template>
	<a v-if="platform === 'facebook'" class="social-share facebook" :href="getShareUrl" target="_blank">
		<Icon icon="Facebook"/>
		<span class="text" v-html="_translate('ui.share.facebook')"></span>
	</a>
	<a v-else-if="platform === 'linkedin'" class="social-share linked" :href="getShareUrl" target="_blank">
		<Icon icon="LinkedIn"/>
		<span class="text" v-html="_translate('ui.share.linkedin')"></span>
	</a>
	<a v-else-if="platform === 'twitter'" class="social-share twitter" :href="getShareUrl" target="_blank">
		<Icon icon="Twitter"/>
		<span class="text" v-html="_translate('ui.share.twitter')"></span>
	</a>
	<a v-else class="social-share email" :href="getShareUrl">
		<Icon icon="Email"/>
		<span class="text" v-html="_translate('ui.share.email')"></span>
	</a>	
</template>

<script>

  import Icon from '@/components/Icon.vue'

	export default {

		components: {
			Icon
		},

		props: {
			platform: {
				type: String,
				default: 'email'
			}
		},

		computed: {

			getShareUrl: function() {

				var link = '';

				switch (this.platform) {

					case ('facebook'):
						link  = 'https://www.facebook.com/sharer/sharer.php?'
						link += 'u=';
						link += window.location.href;
						link += '&t=';
						link += this._translate('share.facebook');
					break;

					case ('twitter'):

						link  = 'https://twitter.com/intent/tweet?';
						link += 'text=';
						link += this._translate('share.tweet');
						link += ' ';
						link += window.location.href; 
					break;

					case ('linkedin'):

						link  = 'https://www.linkedin.com/shareArticle?mini=true';
						link += '&url=';
						link += window.location.href; 
						link += '&title=';
						link += this._translate('share.linkedin');
					break;

					case ('email'):

						link  = 'mailto:?body=';
						link += window.location.href;
						link += '&subject=';
						link += this._translate('share.email');
					break;


				}

				return encodeURI(link);

			},

		}

	}

</script>

<style lang="scss">

	.social-share {
		width: 2rem;
		height: 2rem;
		font-size: 0;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		outline: none;

		background-color: transparent;

		transform: scale(1);

		transition: background-color .3s ease, border-color .3s ease, transform .3s ease;		

		// @include mq(tab) {
		// 	width: 2rem;
		// 	height: 2rem;
		// }

		&:not(.inactive) {

			&:hover,
			&:focus,
			&:active {
				svg { fill: $white; }
			}

		}

		&:focus {
			transform: scale(1.3);
		}

		svg {
			position:relative;
			fill: $white;
			width: 2rem;
			height: 2rem;
		}
	}

</style>
